import * as Sentry from '@sentry/react';

import { SFPlusCircleIcon } from '@assets/icons';
import { useS3Bucket } from '@util/hooks';
import DocumentUploadModal from '@components/general/modals/document-upload-modal.component';

/**
 * A modal component for uploading and summarizing documents.
 * It uses a DocumentDropzone for file input and S3Bucket service for uploading.
 * Displays a toast message during summarization and handles errors with Rollbar.
 * @param {object} props - Component props.
 * @param {object} props.disclosure - Chakra UI disclosure object for controlling the modal state (isOpen, onClose, etc.).
 * @returns {JSX.Element} The SummarizeDocument modal component.
 */

const SummarizeDocument = ({ disclosure }) => {
  const s3 = useS3Bucket('email-parser-processing');

  return (
    <DocumentUploadModal
      disclosure={disclosure}
      headerIcon={
        <SFPlusCircleIcon
          boxSize={7}
          p={1}
        />
      }
      headerText='Summarize a Document'
      submitLabel='Summarize'
      submitTestId='summarize-document-button'
      infoToastTitle={(file) => `Summarizing file ${file?.name}`}
      onSubmit={async ({ file, fileName }) => {
        await s3.uploadFile(file, { fileName });
        await s3.queueDocumentParsing();
      }}
      onError={(error) => {
        Sentry.withScope((scope) => {
          scope.setExtra('error_message', 'Document Upload Error');
          Sentry.captureException(error);
        });
      }}
    />
  );
};

export default SummarizeDocument;
